<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card.primary500--text
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('invite_new_member') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    .pa-6
      .text-lg.font-medium.mb-4 {{ $t('enter_email_new_member') }}
      v-form(ref="form" @submit.prevent)
        yc-text-field(:label="$t('email')" v-model="email" :rules="rules.email" validateOnBlur)
      .text-md.mt-4.mb-16 {{ $t('this_person_received_invitation_email') }}
    v-divider

    v-card-actions.px-6.py-4
      v-spacer
      v-btn.button-md.neutral500--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md.white--text(@click="invite" :loading="isLoading" color="info" depressed :disabled="!email") {{ $t('invite') }}
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: ['open'],
  data: () => ({
    isLoading: false,
    email: '',
    rules: {
      email: [
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ]
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    ...mapState('user', ['member']),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    invite () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        company: this.company.id,
        email: this.email,
        inviter: this.member.id,
        role: 5,
        app: 'connect'
      }
      this.$axios.post(`/invitations`, params)
        .then(resp => {
          this.sendEmailInvitation(resp.data.id)
        })
        .catch(err => {
          const errorMessage = err?.response?.data?.non_field_errors[0] || 'Invite error'
          this.showMessage(['error', errorMessage])
          this.isLoading = false
        })
    },
    sendEmailInvitation (id) {
      this.isLoading = true
      this.$axios.post(`/invitations/${id}/send/?company=${this.company.id}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.invitation_sent_successfully')])
          this.showDialog = false
          this.$emit('invited')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>